export default Object.freeze({
	UPC: 'UPC',
	ASIN: 'ASIN',
	EAN: 'EAN',
	ISBN: 'ISBN',
});
